import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/secretaria`;
export const createSecretaria = async (secretaria) => {
  return await axios.post(`${httpUrl}/create`, secretaria).then((response) => response);
};

export const getListaSecretarias = async (obj) => {
  return await axios
    .get(`${httpUrl}/list`, {
      params: obj,
    })
    .then((response) => response);
};

export const getSecretariaById = async (id) => {
  return await axios.get(`${httpUrl}/${id}`).then((response) => response);
};

export const deleteSecretariaById = async (id) => {
  return await axios.delete(`${httpUrl}/${id}`).then((response) => response);
};
